/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUserSessions} from '../api'

 export const useQueryGetUserSessions = createReactQueryHook('getUserSessions', getUserSessions)
